import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon44: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M2.929 2.92575C6.828 -0.97525 13.172 -0.97525 17.071 2.92575C18.96 4.81475 20 7.32775 20 9.99975C20 12.6718 18.96 15.1848 17.071 17.0748C15.122 19.0248 12.561 19.9998 10 19.9998C7.439 19.9998 4.878 19.0248 2.929 17.0748C1.04 15.1848 0 12.6718 0 9.99975C0 7.32775 1.04 4.81475 2.929 2.92575ZM10 0.999755C7.695 0.999755 5.391 1.87675 3.636 3.63275C1.936 5.33375 1 7.59375 1 9.99975C1 12.4048 1.936 14.6648 3.636 16.3658C7.145 19.8778 12.855 19.8778 16.364 16.3658C18.064 14.6648 19 12.4048 19 9.99975C19 7.59375 18.064 5.33375 16.364 3.63275C14.609 1.87675 12.305 0.999755 10 0.999755ZM10 10.5188C12.478 10.5188 14.668 12.0078 15.581 14.3118C15.682 14.5678 15.557 14.8588 15.3 14.9608C15.239 14.9848 15.177 14.9958 15.116 14.9958C14.917 14.9958 14.729 14.8767 14.651 14.6787C13.891 12.7597 12.065 11.5188 10 11.5188C7.935 11.5188 6.108 12.7598 5.349 14.6778C5.247 14.9358 4.956 15.0627 4.7 14.9597C4.443 14.8577 4.31701 14.5668 4.41901 14.3108C5.33101 12.0078 7.521 10.5188 10 10.5188ZM7 5.99576C7.551 5.99576 8 6.44376 8 6.99576C8 7.54776 7.551 7.99576 7 7.99576C6.449 7.99576 6 7.54776 6 6.99576C6 6.44376 6.449 5.99576 7 5.99576ZM13 5.99576C13.551 5.99576 14 6.44376 14 6.99576C14 7.54776 13.551 7.99576 13 7.99576C12.449 7.99576 12 7.54776 12 6.99576C12 6.44376 12.449 5.99576 13 5.99576Z"
        fill="#A84A76"
      />
    </Icon>
  )
}
